export const squezzeBranches = (branches) => {
    try {
        const squezzedBranch = [];
        if (branches) {
            branches[0].forEach((el, idx) => {
                let amount = branches === null || branches === void 0 ? void 0 : branches.map(branch => branch[idx].amount).reduce((a, b) => a + b, 0);
                squezzedBranch.push({ amount, point: el.point });
            });
        }
        return squezzedBranch;
    }
    catch (e) {
        return [];
    }
};
export const branchesDifference = (firstBranch, secondBranch) => {
    const differenceBranch = [];
    if (firstBranch && secondBranch) {
        firstBranch.forEach((el, idx) => {
            let amount = el.amount - secondBranch[idx].amount;
            differenceBranch.push({ amount, point: el.point });
        });
    }
    return differenceBranch;
};
export const reduceBranch = (branch) => {
    if (branch) {
        return branch === null || branch === void 0 ? void 0 : branch.reduce((a, b) => a + b.amount, 0);
    }
    return [];
};
export const percentageBranches = (branches) => {
    const resultedBranches = JSON.parse(JSON.stringify(branches));
    if (branches) {
        branches[0].forEach((el, idx) => {
            const sum = branches === null || branches === void 0 ? void 0 : branches.map(branch => branch[idx].amount).reduce((a, b) => a + b, 0);
            for (const branch of resultedBranches) {
                const amount = branch[idx].amount;
                const percent = (amount * 100 / sum) || 0;
                if (percent === 0) {
                    branch[idx].amount = '_';
                }
                else {
                    branch[idx].amount = percent.toFixed(2) + ' %';
                }
            }
        });
    }
    return resultedBranches;
};
